export {
  VEHICLE_MARKET_SOURCE_DOMAIN,
  VEHICLE_MARKET_NORMALIZED_SOURCE_TYPES,
  VEHICLE_MARKET_SOURCE_TYPE_LABELS,
  formatVehicleMarketSourceTypeLabel,
  normalizeVehicleMarketSourceType,
  resolveVehicleMarketSourceDomain,
} from "./vehicleMarketSourceConstants.js";

/** Legacy vehicle_source enum values (database / review workflow). */
export const VEHICLE_SOURCE_TYPES = [
  { value: "MARKETPLACE", label: "Marketplace" },
  { value: "DEALER", label: "Dealer" },
  { value: "BRAND_DEALER", label: "Brand dealer" },
  { value: "MANUFACTURER", label: "Manufacturer" },
  { value: "NEW_VEHICLE_PRICE_SOURCE", label: "New vehicle price source" },
  { value: "FLEET_RESALE", label: "Fleet resale" },
  { value: "BANK_RESALE", label: "Bank / remate" },
  { value: "MANUAL", label: "Manual" },
  { value: "OTHER", label: "Other" },
];

/** Virtual filter value — maps to API needs_review=true (compliance queue). */
export const VEHICLE_SOURCE_NEEDS_REVIEW_FILTER = "NEEDS_REVIEW_QUEUE";

export const VEHICLE_SOURCE_STATUSES = [
  { value: "DISCOVERED", label: "Discovered" },
  { value: "REVIEW_PENDING", label: "Review pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "ACTIVE", label: "Active" },
  { value: "BLOCKED", label: "Blocked" },
  { value: "DEPRECATED", label: "Deprecated" },
];

export const VEHICLE_ACCESS_METHODS = [
  { value: "DISCOVERY_PENDING", label: "Discovery pending" },
  { value: "UNKNOWN", label: "Unknown" },
  { value: "HTML_SCRAPE", label: "HTML scrape" },
  { value: "API", label: "API" },
  { value: "SITEMAP", label: "Sitemap" },
  { value: "FEED", label: "Feed" },
  { value: "MANUAL", label: "Manual" },
  { value: "PARTNER", label: "Partner" },
];

export const VEHICLE_REVIEW_STATUSES = [
  { value: "NOT_REVIEWED", label: "Not reviewed" },
  { value: "REVIEW_PENDING", label: "Review pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "APPROVED_WITH_LIMITS", label: "Approved with limits" },
  { value: "BLOCKED", label: "Blocked" },
  { value: "NEEDS_PARTNER_ACCESS", label: "Needs partner access" },
  { value: "UNKNOWN", label: "Unknown" },
];

export const VEHICLE_REVIEW_PRESETS = [
  { value: "approve", label: "Approve source" },
  { value: "approve_with_limits", label: "Approve with limits" },
  { value: "block", label: "Block source" },
  { value: "needs_partner_access", label: "Needs partner access" },
  { value: "reset_review_pending", label: "Reset to review pending" },
];

export const VEHICLE_SOURCE_SORT_OPTIONS = [
  { value: "priority", label: "Priority" },
  { value: "source_name", label: "Source name" },
  { value: "source_type", label: "Source type" },
  { value: "source_status", label: "Status" },
  { value: "updated_at", label: "Last updated" },
  { value: "created_at", label: "Created" },
];

const REVIEW_BADGE_TONES = {
  APPROVED: "confirmed",
  APPROVED_WITH_LIMITS: "medium",
  BLOCKED: "disputed",
  NEEDS_PARTNER_ACCESS: "warning",
  REVIEW_PENDING: "neutral",
  NOT_REVIEWED: "neutral",
  UNKNOWN: "neutral",
};

export function formatVehicleSourceType(value) {
  return VEHICLE_SOURCE_TYPES.find((t) => t.value === value)?.label || value || "—";
}

export function formatVehicleSourceStatus(value) {
  return VEHICLE_SOURCE_STATUSES.find((s) => s.value === value)?.label || value || "—";
}

export function formatVehicleAccessMethod(value) {
  return VEHICLE_ACCESS_METHODS.find((m) => m.value === value)?.label || value || "—";
}

export function formatVehicleReviewStatus(value) {
  return VEHICLE_REVIEW_STATUSES.find((s) => s.value === value)?.label || value || "—";
}

export function vehicleReviewBadgeTone(status) {
  return REVIEW_BADGE_TONES[status] || "neutral";
}
